import { useAuth, overrideConfig } from '@/api/billing-primary'

const fetchAllConsolidated = function ({ qtype, projectIdx, groupIdx, month, estimated }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    let params = {
        qtype,
        estimated,
        groupIdx: qtype === 'project' || qtype === 'all' ? null : groupIdx,
        projectIdx: qtype === 'group' || qtype === 'all' ? null : projectIdx,
        month
    }
    return auth.axiosIns.post('/v1/context', { target: 'AllConsolidated', params })
}

export default {
    fetchAllConsolidated
}
